import { useMemo } from "react"
import { createModel } from "hox"
import useUserModel from "./useUserModel"
import usePanelModel from "./usePanelModel"
import { useSetState } from "@/reactUse"

function useShareModel() {
  const [state, set] = useSetState({ isShare: false, isOpenShare: false })
  const { userInfo } = useUserModel()
  const { userName } = usePanelModel()

  useMemo(() => {
    set({ isShare: userInfo.user_name !== userName })
  }, [userInfo.user_name, userName, set])

  return {
    ...state,
    set,
  }
}

export default createModel(useShareModel)
